import React from 'react';
import '@chewy/pet-profile-ux-components/dist/esm/main.css';
import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css';
import '@chewy/kib-fields-styles/dist/styles/kib-input-text.css';
import '@chewy/kib-messaging-styles/dist/styles/kib-snackbar-manager.css';
import '@chewy/kib-messaging-styles/dist/styles/kib-snackbar.css';
import '@chewy/kib-transition-styles/dist/kib-transition.css';
import './components-page.scss';
import { KibPlaceholderIcon } from '@chewy/kib-icons-react';
import { PetSelectorCardsSection } from './PetSelectorCardsSection';
import { CreatePetProfileSheetSection } from './CreatePetProfileSheetSection';

export default function ComponentsPage() {
  return (
    <div className="testing-page">
      <h1 key="title">
        <KibPlaceholderIcon className="icon" /> Pet Profile UX Components
      </h1>
      <CreatePetProfileSheetSection />
      <PetSelectorCardsSection />
    </div>
  );
}
